export const DEFAULT_ZOOM = 19;
export const DEFAULT_CENTER = {
    lat: -6.2088,
    lng: 106.845,
};
